module.exports = __webpack_public_path__ + "static/media/displiner.6243c792.png";